module.exports = __webpack_public_path__ + "img/depto.9129bec9.png";